<!-- TODO : Obligé de cliquer 2 fois sur le select pour qu'il s'ouvre -->
<kal-card (dismissed)="closeFilters()"
          [dismissable]="true">

    <kal-card-title>
        Filtrer
    </kal-card-title>

    <kal-card-content>

        <div class="gup-C-flexGroup -row">

            <div class="gup-C-flexGroup__item -full">

                <kal-form-field>

                    <kal-select id="image_bank_dialog_filters_tag"
                                label="Tag"
                                [formControl]="tagControl">

                        <kal-option [value]="null">
                            Tous
                        </kal-option>

                        <kal-option *ngFor="let tag of tagsList"
                                    [value]="tag">
                            {{ tag }}
                        </kal-option>

                    </kal-select>

                </kal-form-field>

            </div>

        </div>

    </kal-card-content>

    <kal-card-actions>

        <kal-button id="image_bank_dialog_filters_apply"
                    kalTheme="primary"
                    (click)="applyFilters()">
            Appliquer
        </kal-button>

        <kal-button id="image_bank_dialog_filters_cancel"
                    kalTheme="secondary"
                    (click)="closeFilters()">
            Annuler
        </kal-button>

    </kal-card-actions>

</kal-card>
